// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.food_project_status_enum */
var FoodProjectStatusEnum;
(function (FoodProjectStatusEnum) {
    FoodProjectStatusEnum["active"] = "active";
    FoodProjectStatusEnum["on_hold"] = "on_hold";
    FoodProjectStatusEnum["completed"] = "completed";
})(FoodProjectStatusEnum || (FoodProjectStatusEnum = {}));
;
export default FoodProjectStatusEnum;
/** Zod schema for food_project_status_enum */
export const foodProjectStatusEnum = z.nativeEnum(FoodProjectStatusEnum);
//# sourceMappingURL=FoodProjectStatusEnum.js.map